module.exports = __webpack_public_path__ + "static/p2p-finance-header-2d1fdeac914f63f8c611f41d0a808971.png";